import script from "./VerticalMarket331.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerticalMarket331.vue?vue&type=script&setup=true&lang=ts"

import "./VerticalMarket331.vue?vue&type=style&index=0&id=3aafa996&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aafa996"]])

export default __exports__